import moment from 'moment-timezone'

export const roundHours = hours => hours //Math.floor(hours*4)/4

export const formatHours = hours => {
  const r = roundHours(hours)
  const m = Math.floor((r - Math.floor(r))*60)
  if (m == 0) 
    return `${Math.floor(r)}`
  else 
  if (m < 10) 
    return `${Math.floor(r)}:0${m}`
  else
    return `${Math.floor(r)}:${m}`
}



export function dateToFortnight(date) {
  const base = moment(new Date(2018, 3, 4))
                .subtract(14*100, 'days')
                .startOf('week').add(3, 'days')
  const md = moment(date)
  let spw = null
  const diff = Math.abs(md.diff(base, 'days'))
  spw = md.subtract(diff % 14, 'days')

  return {
    from: spw.toDate(),
    to  : spw.add(13, 'days').toDate() 
  }
}



// WEBPACK FOOTER //
// ./src/utils/time.js